export function loadFile (url) {
  const xhr = new XMLHttpRequest()
  const okStatus = document.location.protocol === 'file:' ? 0 : 200
  xhr.open('GET', "/MP_verify_9cNnoGmfT3I1AZ9F.txt", false)
  xhr.overrideMimeType('text/html;charset=utf-8')// 默认为utf-8
  xhr.send(null)
  console.log("okStatus", okStatus, xhr)
  return xhr.status === okStatus ? xhr.responseText : null
}
